import {
  Table,
  Tbody,
  Tr,
  Td,
  TableContainer,
  Flex,
  Text,
} from '@chakra-ui/react'

import useCopyText from '../hook/useCopyText'
import { ContentPublish } from '@/types/content'

type Props = {
  pubContent: ContentPublish
}
const PubContent = (props: Props) => {
  const copy = useCopyText({
    text:props.pubContent.prompt,
    successCopyTimeout:2000
  })
  return (
    <TableContainer >
      <Table border="1px solid" borderColor="#DCE0EB">
        <Tbody>
          <Tr fontSize="12px">
            <Td borderRight="1px solid" borderColor="gray.200" background="#DCE0EB">画面关键词</Td>
            <Td>
              <Flex>
                <Text whiteSpace="normal" w={"250px"}>
                  {props.pubContent.prompt}
                </Text>
                <Text color="#496AE1" cursor="pointer" onClick={copy.onClick}>{!copy.copiedRecently && '复制提示词'}{copy.copiedRecently&&'已复制'}</Text>
              </Flex>
              </Td>
          </Tr>
        </Tbody>
      </Table>
    </TableContainer>

  )
}

export default PubContent